// Tema moderno y futbolero: base verde césped + azul + blanco.
// `accent` = verde (primario), `gold` = azul (secundario/realce). `live` = rojo (solo "en juego").

export interface AppTheme {
  name: 'light' | 'dark';
  colors: {
    bg: string;
    surface: string;
    surfaceAlt: string;
    border: string;
    borderStrong: string;
    text: string;
    textMuted: string;
    accent: string;
    accentDark: string; // extremo oscuro de los degradés (derivado del acento)
    accentText: string;
    gold: string; // (histórico: nombre legado) → ahora azul secundario
    live: string;
    danger: string;
    timba: string; // verde manzana: realce del pronóstico cargado en la card del partido
    boost: string; // ámbar: badge de booster (×2/×3/×4) de la timba
  };
  radius: string;
  maxWidth: string;
}

export const dark: AppTheme = {
  name: 'dark',
  colors: {
    bg: '#0c1622',
    surface: '#13202f',
    surfaceAlt: '#1b2c3f',
    border: '#26384d',
    borderStrong: '#3a506b',
    text: '#eef3f8',
    textMuted: '#aebdd0',
    accent: '#1aa86a', // verde césped
    accentDark: '#0a3d2c',
    accentText: '#ffffff',
    gold: '#3b82f6', // azul
    live: '#ef4444',
    danger: '#ef4444',
    timba: '#9acd32', // verde manzana
    boost: '#f59e0b', // ámbar
  },
  radius: '14px',
  maxWidth: '720px',
};

export const light: AppTheme = {
  name: 'light',
  colors: {
    bg: '#eef3f7',
    surface: '#ffffff',
    surfaceAlt: '#e4edf3',
    border: '#d4dfe9',
    borderStrong: '#aebccd',
    text: '#0e1b2a',
    textMuted: '#475263',
    accent: '#0f9d63', // verde césped
    accentDark: '#0a3d2c',
    accentText: '#ffffff',
    gold: '#2563eb', // azul
    live: '#dc2626',
    danger: '#dc2626',
    timba: '#9acd32', // verde manzana
    boost: '#d97706', // ámbar
  },
  radius: '14px',
  maxWidth: '720px',
};

export const themes = { dark, light };
